import Mutations from '../../odata/mutations';

export default { ...new Mutations('trainingItem'), ...new Mutations('trainingItems') };
